module.exports = __webpack_public_path__ + "img/footer-logo-en.0736df0e.png";